import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { accessRows, accessChecks } from '../../data/instantAccess';
export function InstantAccess() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-138" data-mp="39dq55tozbejc">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-139" data-mp="34c0s68i74qsm">
        <SectionTag icon="📦" data-id="element-140" data-mp="30bqnr0a1y8fv">Acceso inmediato</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-141" data-mp="30dbior0a3te9">
          Esto lo recibes en tu correo hoy mismo.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-142" data-mp="2qm73prals8jf">
          Material profesional descargable al instante, sin esperar envíos.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 sm:px-6" data-id="element-143" data-mp="2gnhknv6z0i1l">
        <ScrollHintTable minWidth="420px" data-id="element-144" data-mp="2gp2gdo50u711">
          <table className="w-full text-left text-sm" data-id="element-145" data-mp="2cle9z8s4lhhd">
            <thead data-id="element-146" data-mp="2co0et0nmtivw">
              <tr className="border-b border-white/10 bg-white/5 text-xs uppercase tracking-wide text-muted" data-id="element-147" data-mp="35oyhu30biz6m">
                <th className="px-5 py-3 font-semibold" data-id="element-148" data-mp="3afwxr1he9v9c">Formato</th>
                <th className="px-5 py-3 font-semibold" data-id="element-149" data-mp="3ah81j1aub30g">Contenido</th>
                <th className="px-5 py-3 font-semibold" data-id="element-150" data-mp="2vs3ixj04uwrt">Páginas</th>
              </tr>
            </thead>
            <tbody data-id="element-151" data-mp="30pvb8e4owkwj">
              {accessRows.map((row, i) => <tr key={row.content} className={i !== accessRows.length - 1 ? 'border-b border-white/5' : ''} data-id="element-152" data-mp="3og7swgpqlw0b" data-mpi={i}>
                  <td className="whitespace-nowrap px-5 py-4 text-white" data-id="element-153" data-mp="3tcyax9l3r1od">{row.format}</td>
                  <td className="px-5 py-4 text-muted" data-id="element-154" data-mp="3fdghggwv308o">{row.content}</td>
                  <td className="whitespace-nowrap px-5 py-4 font-semibold text-lime" data-id="element-155" data-mp="3jfk3fzh5pn87">{row.pages}</td>
                </tr>)}
            </tbody>
          </table>
        </ScrollHintTable>

        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-156" data-mp="281fzq1krokpy">
          {accessChecks.map(check => <div key={check} className="flex items-center gap-2 text-sm text-white" data-id="element-157" data-mp="eh5zxhs65slu">
              <CheckIcon size={16} className="text-success" data-id="element-158" data-mp="9iuo51ibd80z" />
              {check}
            </div>)}
        </div>
      </div>
    </section>;
}